import { type FirebaseApp, initializeApp } from 'firebase/app';
import {
  forceWebSockets,
  getDatabase,
  onValue,
  ref,
  type Database,
  type DatabaseReference,
  type DataSnapshot,
  type ListenOptions,
  type Query,
  type Unsubscribe,
} from 'firebase/database';
import {
  NEXT_PUBLIC_FIREBASE_API_KEY,
  NEXT_PUBLIC_FIREBASE_DATABASE,
  NEXT_PUBLIC_FIREBASE_PROJECT_ID,
} from './env';

const config = {
  apiKey: NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: `${NEXT_PUBLIC_FIREBASE_PROJECT_ID}.firebaseapp.com`,
  databaseURL: NEXT_PUBLIC_FIREBASE_DATABASE,
  projectId: NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: `${NEXT_PUBLIC_FIREBASE_PROJECT_ID}.appspot.com`,
  messagingSenderId: '949599212204',
  appId: '1:949599212204:web:6f3110ef4195f109',
  measurementId: 'G-4X89L7GP2J',
};

let appInstance: FirebaseApp;
let websocketTransportForced = false;
function getAppInstance() {
  if (appInstance) {
    return appInstance;
  }
  appInstance = initializeApp(config);

  return appInstance;
}

const getDatabaseWithWebSockets = (app?: FirebaseApp, url?: string) => {
  if (!websocketTransportForced) {
    forceWebSockets();
    websocketTransportForced = true;
  }

  return getDatabase(app, url);
};

export {
  getAppInstance,
  getDatabaseWithWebSockets as getDatabase,
  onValue,
  ref,
  type Database,
  type DatabaseReference,
  type DataSnapshot,
  type FirebaseApp,
  type ListenOptions,
  type Query,
  type Unsubscribe,
};
